export const socialLinks = [
	{
		id: 1,
		name: 'Website',
		icon: 'globe',
		url: '#',
	},
	{
		id: 2,
		name: 'GitHub',
		icon: 'github',
		url: 'https://github.com/Kuyawill14',
	},
	{
		id: 4,
		name: 'LinkedIn',
		icon: 'linkedin',
		url: 'https://www.linkedin.com/in/magaoay-wilson-b93076248/',
	},
];
